module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedHeavy.f8cd024.woff2";